module.exports = __webpack_public_path__ + "img/down_bg.7c90e64e.png";